<template>
	<div class="basis-page-cls">
		 <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
		<section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 批次详情</span>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList">
				</table-pagination>
            </div>
        </section>
	</div>
</template>

<script>
import { tableMixin } from "utils/mixins";
export default {
	props: ['itemData'],
	mixins: [tableMixin],
	data() {
		const formatDate = Vue.filter('formatDate');
		return {
			column: [
				{
					label: '序号',
					width: 50,
					align: 'center',
					render: (h, scope) => {
						return (
							<span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
						)
					}
				},
				{label: '客户ID', prop: 'customerId'},
				{label: '客户姓名', prop: 'customerName'},
				{label: '手机号码', prop: 'mobileNum'},
				{
					label: '预约发送时间',
					render: (h, scope) => {
						return (
							<span>{formatDate(scope.row.scheduleTime)}</span>
						)
					}
				},
				{
					label: '发送时间',
					render: (h, scope) => {
						return (
							<span>{formatDate(scope.row.sendTime)}</span>
						)
					}
				},
				{ 
					label: '发送状态', 
					render: (h, scope) => {
						return (
							<el-tag size="mini" type={scope.row.sendStatus == 'sent' ? 'success' : scope.row.sendStatus == 'failed' ? 'danger' : scope.row.sendStatus == 'cancel' ? 'info' : ''}>{scope.row.sendStatus == 'sent' ? '已发送' : scope.row.sendStatus == 'failed' ? '已失败' : scope.row.sendStatus == 'cancel' ? '已取消' : '预约中'}</el-tag>
						)
					}
				},
				{ 
					label: '回执状态', 
					render: (h, scope) => {
						return (
							<el-tag size="mini" type={scope.row.providerStatus == 'success' ? 'success' : scope.row.providerStatus == null ? '' : 'danger'}>{scope.row.providerStatus == 'success' ? '已送达' : scope.row.providerStatus == null ? '---' : '其他'}</el-tag>
						)
					}
				},
			],
			filterHeader: [
				{ label: '发送状态', model: 'sendStatus', type: 'select', default: '', list: [
					{id: 'ready', name: '预约中'},
					{id: 'sent', name: '已发送'},
					{id: 'failed', name: '已失败'},
					{id: 'cancel', name: '已取消'}
				] },
				{ label: '回执状态', model: 'providerStatus', type: 'select', default: '', list: [
					{id: 'success', name: '已送达'},
					{id: 'other', name: '其他'},
				] },
				{ label: '手机号', model: 'mobileNum', type: 'input', default: '', placeholder: '请输入手机号' },
				{ label: '客户姓名', model: 'customerName', type: 'input', default: '', placeholder: '请输入客户姓名' },
			],
			listQuery: {
				id: '',
				pageNum: 1,
				pageSize: 10,
				sendStatus: '',
				providerStatus: '',
				mobileNum: '',
				customerName: '',
			},
			list: [],
			total: 0
		}
	},
	watch: {
		itemData: {
			handler() {
				this.getList();
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		getList() {
			this.listQuery.id = this.itemData.id;
			this.$api.apiPostSmsSendGroupDetailsList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response['list'];
				this.total = response.total;
			});
		},
		handelDownload(row) {
			window.open(row.ftpBase);
		},
		filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList();
		}
	}
}
</script>
